<template>
  <div class="small-menu-category-card">
    <nuxt-link
      :to="absolutePath(link)"
      :aria-label="categoryName"
    >
      <nuxt-img
        v-if="icon"
        :src="icon"
        :alt="categoryName"
        class="small-menu-category-card__image"
        loading="lazy"
        width="50"
        height="50"
        format="webp"
        quality="85"
        preload
        sizes="50px sm:40px"
      />
      <p
        v-if="categoryName"
        class="small-menu-category-card__title"
      >
        {{ categoryName }}
      </p>
    </nuxt-link>
  </div>
</template>

<script setup lang="ts">
import type { ICategory } from '#sitis/internal/controllers/categories/models/Category';
import absolutePath from "~/utils/absolutePath";

const props = defineProps<{
  item: ICategory | null
}>()

// Оптимизация: кешируем вычисления
const link = computed(() => String(props.item?.url || ''))
const icon = computed(() => String(props.item?.dynamicFields?.menu_icon || ''))
const categoryName = computed(() => props.item?.name || '')
</script>

<style scoped lang="scss">
.small-menu-category-card {
  padding: 10px 20px;
  border: 1px solid rgba(244, 243, 241, 1);
  border-radius: 10px;
  cursor: pointer;
  height: 100%;
  
  // Оптимизация: CSS containment для изоляции карточки
  contain: layout style paint;
  
  // Оптимизация: GPU acceleration
  transform: translateZ(0);

  &:hover {
    .small-menu-category-card__image {
      opacity: 1;
    }
    .small-menu-category-card__title {
      opacity: 1;
    }
  }
}
.small-menu-category-card__image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  opacity: 0.5;
  
  // Оптимизация: использовать только opacity для transition (самое быстрое)
  transition: opacity 0.2s ease;
  
  // Оптимизация: предотвращение layout shift
  aspect-ratio: 1 / 1;
  display: block;
}
.small-menu-category-card__title {
  padding-top: 14px;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0;
  opacity: 0.5;
  transition: opacity 0.2s ease;
  
  // Оптимизация: предотвращение переноса и пересчета layout
  word-break: break-word;
  overflow-wrap: break-word;
}
@media screen and (max-width: 640px) {
  .small-menu-category-card {
    padding: 12px 16px;
  }
  .small-menu-category-card__title {
    padding-top: 6px;
  }
  .small-menu-category-card__image {
    width: 40px;
    height: 40px;
  }
}
</style>
